/* eslint-disable eqeqeq */
import { useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Tab } from 'semantic-ui-react';
import thousands from 'thousands';

import {
  PostSurveyChart,
  PostPreTrendSurvey,
} from '../../../reports/reportHome/outcomesSummary';

import { getChartType } from '../../../../utils';

import './systemReport.scss';

const SystemOverview = (props) => {
  const { t } = useTranslation();

  const { type, setChartType, systemOverviewSummary } = props;

  useEffect(() => {
    const chartType = getChartType({
      title: type,
      ...props,
    });
    setChartType(chartType);
  }, [type, setChartType, props]);

  useEffect(() => {
    const chartType = getChartType({
      title: type,
      ...props,
    });
    setChartType(chartType);
  }, [type, setChartType, props]);

  return (
    <div>
      <div className="system-report-admin">
        <div className="com-title">
          {t('admin.system_reports.completed_activities')}
        </div>
      </div>

      <div className="completion">
        <Grid className="system-summary-grid" padded>
          <div className="org-count">
            <div>
              <div className="title-org">
                {t('admin.system_reports.account_count')}
              </div>
              <div className="count-value">
                {systemOverviewSummary.completed
                  ? thousands(systemOverviewSummary.completed.orgCount)
                  : '-'}
              </div>
            </div>

            <div className="adjust-left">
              <div className="title-org">
                {t('admin.system_reports.activity_count')}
              </div>
              <div className="count-value">
                {systemOverviewSummary.completed
                  ? thousands(systemOverviewSummary.completed.activityCount)
                  : '-'}
              </div>
            </div>

            <div className="adjust-left">
              <div className="title-org">
                {t('admin.system_reports.actual_expenditures')}
              </div>
              <div className="count-value">
                {systemOverviewSummary.completed
                  ? `$${thousands(
                      systemOverviewSummary.completed.actualExpenditure
                    )}`
                  : '-'}
              </div>
            </div>
          </div>
        </Grid>
      </div>

      <Grid className="outcomes-summary-grid" padded>
        <Grid.Row className="outcomes-chart-row">
          <div className="outcomes-summary-chart-div">
            {type === 'All Outcomes' ? (
              <Tab
                className="tabs-graph"
                menu={{ secondary: true, pointing: true }}
                panes={[
                  {
                    menuItem: t('admin.system_reports.aggregrate_tab'),
                    render: () => (
                      <Tab.Pane>
                        <PostSurveyChart {...props} />
                      </Tab.Pane>
                    ),
                  },
                  {
                    menuItem: t(
                      'admin.system_reports.trend_rate_of_change_tab'
                    ),
                    render: () => (
                      <Tab.Pane>
                        <PostPreTrendSurvey method="all" {...props} />
                      </Tab.Pane>
                    ),
                  },
                ]}
              />
            ) : (
              <Fragment>
                {getChartType({ title: type, ...props }) === 'postChart' ? (
                  <PostSurveyChart {...props} />
                ) : null}
                {getChartType({ title: type, ...props }) === 'prePostChart' ? (
                  <PostPreTrendSurvey method="all" {...props} />
                ) : null}
              </Fragment>
            )}
          </div>
        </Grid.Row>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    participantsChangePrePost: state.report.participantsChangePrePost,
    participants: state.report.participants,
    systemOverviewSummary: state.report.systemOverviewSummary,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemOverview);
